import { ModuleLayout, SkeletonBox } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BankingOnboardingEmptyState } from '@features/bankAccounts/elements/BankingOnboardingEmptyState'
import { useShouldShowBankingOnboarding } from '@features/bankAccounts/hooks/useShouldShowBankingOnboarding'
import { ReconciliationViewBanner } from '@features/bankTransactions/elements/ReconciliationViewBanner/ReconciliationViewBanner'
import { ReconciliationViewBannerPage } from '@features/bankTransactions/enums/reconciliationViewBannerPage'
import { useBankTransactionsFilters } from '@features/bankTransactions/hooks/useBankTransactionsFilters'
import { useBankTransactionsSandbox } from '@features/bankTransactions/hooks/useBankTransactionsSandbox'
import { UiSource } from '@features/reconciliation/enums'
import { BankTransactionsSandbox } from '@views/bankTransactions/routes/BankTransactionsSandbox'

import { BankTransactionsContent } from './BankTransactionsContent'
import * as Styled from './styles'

export const BankTransactions = (): ReactElement => {
  const { t } = useTranslation()
  const [{ accountId }] = useBankTransactionsFilters()
  const { isLoading, shouldShowBankingOnboarding } = useShouldShowBankingOnboarding()
  const { isSandboxOpen, closeSandbox, openSandbox } = useBankTransactionsSandbox()

  return (
    <Styled.PageWrapper>
      <ReconciliationViewBanner accountId={accountId} page={ReconciliationViewBannerPage.Transactions} />
      <Styled.ModuleLayoutContainer>
        <ModuleLayout
          title={shouldShowBankingOnboarding ? t('navigation.menu.label.banking.bank_transactions') : undefined}
        >
          {isLoading && <SkeletonBox height={280} fullWidth />}
          {!isLoading && shouldShowBankingOnboarding && (
            <BankingOnboardingEmptyState onTryDemo={openSandbox} uiSource={UiSource.TransactionViewEmptyState} />
          )}
          {!isLoading && !shouldShowBankingOnboarding && <BankTransactionsContent />}
          {isSandboxOpen && <BankTransactionsSandbox onClose={closeSandbox} />}
        </ModuleLayout>
      </Styled.ModuleLayoutContainer>
    </Styled.PageWrapper>
  )
}
